import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import Mobile from './components/Mobile';
import Desktop from './components/Desktop';
import { HOMEPAGE_POPULAR_CITIES_CLICK } from '../../core/analytics/events';
import history from '../../core/history/index';
import { getCityDirectoryUrl } from '../../core/util/seo';
import { analyticsTrackEvent } from '../../core/analytics/index';
import { getDefaultBreakpoint } from '../../core/util/device/screen';

class AppFooter extends Component {
  render() {
    const popularCities = [
      { id: 'Dallas', city: 'Dallas', state: 'TX' },
      { id: 'Fort Worth', city: 'Fort Worth', state: 'TX' },
      { id: 'Seattle', city: 'Seattle', state: 'WA' },
      { id: 'San Antonio', city: 'San Antonio', state: 'TX' },
      { id: 'Reno', city: 'Reno', state: 'NV' },
      { id: 'Phoenix', city: 'Phoenix', state: 'AZ' },
      { id: 'Elkridge', city: 'Elkridge', state: 'MD' },
      { id: 'Mesa', city: 'Mesa', state: 'AZ' },
      { id: 'Plano', city: 'Plano', state: 'TX' },
      { id: 'Tulsa', city: 'Tulsa', state: 'OK' },
      { id: 'Cedar Park', city: 'Cedar Park', state: 'TX' },
    ];

    const onPopularCityClick = (city, state) => {
      analyticsTrackEvent(HOMEPAGE_POPULAR_CITIES_CLICK, { city, state });
    };

    return (
      <footer id="footer">
        <Hidden smDown initialWidth={getDefaultBreakpoint()}>
          <Desktop popularCities={popularCities} onPopularCityClick={onPopularCityClick} />
        </Hidden>
        <Hidden mdUp initialWidth={getDefaultBreakpoint()}>
          <Mobile popularCities={popularCities} onPopularCityClick={onPopularCityClick} />
        </Hidden>
      </footer>
    );
  }
}

AppFooter.propTypes = {
  popularCities: PropTypes.array,
};

AppFooter.defaultProps = {
  popularCities: [],
};

export default AppFooter;
